export function getParameterizedString(inputString, parameters) {
    var parameterizedResult = inputString
    if(inputString && parameters && parameters.length > 0) {
        for(var i=0; i < parameters.length; i++) {
            parameterizedResult = parameterizedResult.replace('{'+i+'}', parameters[i])
        }
    }
    return parameterizedResult
}